
import { useRef } from 'react';
import { useSessionState } from './useSessionState';
import { useSessionChecker } from './useSessionChecker';
import { useAuthChangeListener } from './useAuthChangeListener';
import { SessionManager } from './types';

export function useSessionManager(): SessionManager {
  const { 
    user, 
    session, 
    isLoading, 
    lastError,
    setUser,
    setSession,
    setIsLoading,
    setLastError
  } = useSessionState();
  
  const isMountedRef = useRef(true);
  
  const { checkSession } = useSessionChecker({
    setUser,
    setSession,
    setIsLoading,
    setLastError,
    isMountedRef
  });
  
  useAuthChangeListener({
    checkSession,
    setUser,
    setSession,
    setIsLoading,
    setLastError,
    isMountedRef
  });
  
  // Cleanup on unmount
  const cleanupRef = useRef(() => {
    isMountedRef.current = false;
  });
  
  // Return the session management API
  return {
    user,
    session,
    isLoading,
    lastError,
    setUser,
    setSession,
    checkSession
  };
}
